import type { WebSiteEntity, SchemaRef } from '../core/types'

export function buildSchemaWebSite(options: {
  id?: string
  name?: string
  url?: string
  inLanguage?: string
  description?: string
  publisher?: SchemaRef
}): WebSiteEntity {
  return {
    '@type': 'WebSite',
    ...(options.id ? { '@id': options.id } : {}),
    ...(options.name ? { name: options.name } : {}),
    ...(options.url ? { url: options.url } : {}),
    ...(options.inLanguage ? { inLanguage: options.inLanguage } : {}),
    ...(options.description ? { description: options.description } : {}),
    ...(options.publisher ? { publisher: options.publisher } : {})
  }
}
